const publicUrl = process.env.PUBLIC_URL || '';

const blogPosts = [
  {
    id: 'sourdough-time',
    category: 'Artisan bread',
    title: 'Why sourdough needs time',
    image: `${publicUrl}/images/breads/dinkel-pure.jpg`,
    imageAlt: 'Homemade spelt sourdough bread',
    readLabel: 'Read more',
    to: `${publicUrl}/Blog/sourdough`,
    toByLanguage: {
      de: `${publicUrl}/Blog/sauerteig`,
      bg: `${publicUrl}/Blog/kvas`,
    },
  },
  {
    id: 'tea-moments',
    category: 'Sourdough craft',
    title: 'Fermentation creates character',
    image: `${publicUrl}/images/breads/dinkel-fruits2.jpg`,
    imageAlt: 'Sliced homemade sourdough bread',
    readLabel: 'Read more',
    to: `${publicUrl}/Blog/what-is-sourdough`,
    toByLanguage: {
      de: `${publicUrl}/Blog/was-ist-sauerteig`,
      bg: `${publicUrl}/Blog/kakvo-e-kvas`,
    },
  },
  {
    id: 'sweet-finish',
    category: 'Sourdough craft',
    title: 'From starter to crust',
    image: `${publicUrl}/images/breads/bread-slice.webp`,
    imageAlt: 'Fresh bread with a golden crust',
    readLabel: 'Read more',
    to: `${publicUrl}/Blog/from-starter-to-crust`,
    toByLanguage: {
      de: `${publicUrl}/Blog/vom-anstellgut-bis-zur-kruste`,
      bg: `${publicUrl}/Blog/ot-kvasa-do-korichkata`,
    },
  },
];

export default blogPosts;
